import React, {useEffect, useRef, useState} from "react";
import {Toast} from 'primereact/toast';
import FaultyProductManagementService from "./httpService";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {ResponsiveDataTable} from "../../components/ResponsiveDataTable";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import {InputText} from "primereact/inputtext";
import BarcodeScanner from "../SalesScreen/BarcodeScanner";
import {Dropdown} from "primereact/dropdown";

const FaultyProductList = () => {

  const resellerId = JSON.parse(localStorage.getItem('user')).user?.loginReseller?.id;
  const toast = useRef(null);
  const faultyProductManagementService = new FaultyProductManagementService();

  const [loading, setLoading] = useState(false);
  const [searchCriteriaLazyLoading, setSearchCriteriaLazyLoading] = useState(false);
  const [searchCriteriaProgressing, setSearchCriteriaProgressing] = useState(false);
  const [saleInfoList, setSaleInfoList] = useState([]);

  const [searchCriteria, setSearchCriteria] = useState({});

  const [detailModal, setDetailModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(false);
  const [selectedFaultyProductInfoStatus, setSelectedFaultyProductInfoStatus] = useState(null);

  const [paginationConfig, setPaginationConfig] = useState({
    itemsPerPage: 10,
    first: 0,
    totalRecords: 30,
    activePage: 0,
  });

  const [faultyProductInfoStatusOptions, setFaultyProductInfoStatusOptions] = useState(
    [
      {value: "WAITING", name: "Bekliyor"},
      {value: "APPROVED", name: "Onaylandı"},
      {value: "REJECTED", name: "Reddedildi"}
    ]
  );

  useEffect(() => {
    searchTicket({...paginationConfig, activePage: 0});
  }, []);

  useEffect(() => {
    setSearchCriteriaLazyLoading(true);
  }, [searchCriteria, selectedFaultyProductInfoStatus]);

  useEffect(() => {
    if (searchCriteriaLazyLoading) {
      setTimeout(() => {
        setSearchCriteriaProgressing(true);
        setSearchCriteriaLazyLoading(false);
      }, 2000);
    }
  }, [searchCriteriaLazyLoading]);

  useEffect(() => {
    if (searchCriteriaProgressing) {
      searchTicket({...paginationConfig, activePage: 0});
      setSearchCriteriaProgressing(false);
    }
  }, [searchCriteriaProgressing]);

  const searchTicket = (pageState) => {
    setLoading(true);
    var sort = "";
    if (searchCriteria.sortField != null && searchCriteria.sortOrder != null) {
      sort += searchCriteria.sortField;
      if (searchCriteria.sortOrder == 1) {
        sort += ",asc";
      } else {
        sort += ",desc";
      }
    } else {
      sort += "createDateTime,desc";
    }

    searchCriteria.resellerId = resellerId;
    searchCriteria.faultyProductInfoStatus = selectedFaultyProductInfoStatus;

    faultyProductManagementService.searchTicket(searchCriteria, pageState.itemsPerPage, pageState.activePage, sort).then(res => {
      console.log("searchSaleInfo", res.content);
      if (res.content && res.content.length > 0) {
        setSaleInfoList(res.content);

        pageState.totalRecords = res.totalElements;
        pageState.first = pageState.itemsPerPage * pageState.activePage;
        setPaginationConfig({
          ...pageState,
        });
      } else {
        setSaleInfoList([]);
      }
    }).catch(err => {
      toast?.current?.show({
        severity: 'error',
        summary: 'Hata',
        detail: 'İşlem bilgisi getirme başarısız.'
      });
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });
  };

  const onActivePageChange = (e) => {
    let pageState = {
      ...paginationConfig,
      itemsPerPage: e.rows,
      activePage: e.page,
    };
    searchTicket(pageState);
  };

  const onFilter = (e) => {
    let _lazyParams = {...searchCriteria, ...e};
    setSearchCriteria(_lazyParams);
  };

  const onSort = (e) => {
    let _lazyParams = {...searchCriteria, ...e};
    setSearchCriteria(_lazyParams);
  };

  const detailModalShow = (e) => {
    setDetailModal(true);
    saleInfoList.forEach(s => {
      if (s.id == e.currentTarget.id) {
        setSelectedProduct(s);
      }
    });
  };

  const detaillModalHide = () => {
    setDetailModal(false);
  };

  const responsiveColumn = (title, content) => {
    return (
      <div>
        <div className="p-column-title">{title}</div>
        {content}
      </div>
    );
  };

  const createDateTimeStringTemplate = (data) => {
    return responsiveColumn("Bildirim Tarihi", data?.createDateTimeString)
  };

  const faultyProductInfoStatusDisplayTemplate = (data) => {
    return responsiveColumn("Durum", data?.faultyProductInfoStatusDisplay)
  };

  const serialNoTemplate = (data) => {
    return responsiveColumn("Seri Numara", data?.productSerialNo?.serialNo)
  };

  const barcodeTemplate = (data) => {
    return responsiveColumn("Barkod", data?.model?.barcode)
  };

  const resellerCodeTemplate = (data) => {
    return responsiveColumn("Bayi", data?.reseller?.code + " - " + data?.reseller?.name)
  };

  const accessoryCampaignSerialTitleButtonTemplate = (data) => {
    return (
      <div className="p-d-flex p-justify-even">
        <Button id={data.id} type="button" className="p-button-sm p-button-info" label="Detay"
                onClick={detailModalShow}/>
      </div>
    );
  };

  const renderSaleStatusFilter = () => {
    return (
      <Dropdown value={selectedFaultyProductInfoStatus} options={faultyProductInfoStatusOptions}
                onChange={(e) => setSelectedFaultyProductInfoStatus(e.value)}
                optionLabel="name" optionValue="value" showClear className="p-column-filter"/>
    );
  };

  const saleStatusFilterElement = renderSaleStatusFilter();

  return (
    <>
      <Toast ref={toast}/>
      <div className="datatable-responsive-demo">
        <div className="card p-grid">
          <div className="p-col-12">
            <ResponsiveDataTable
              lazy
              header="Bildirilen Arızalı Ürünler"
              value={saleInfoList}
              paginationConfig={paginationConfig}
              onActivePageChange={onActivePageChange}
              onFilter={onFilter}
              filters={searchCriteria.filters}
              onSort={onSort}
              sortField={searchCriteria.sortField}
              sortOrder={searchCriteria.sortOrder}
              loading={loading}
              emptyMessage="Bildirilen arızalı ürün bulunamadı"
            >
              <Column field="createDateTime" body={createDateTimeStringTemplate} header="Bildirim Tarihi" sortable/>
              <Column field="faultyProductInfoStatusDisplay" body={faultyProductInfoStatusDisplayTemplate}
                      header="Durum" filter={true}
                      filterElement={saleStatusFilterElement}/>
              <Column field="serialNo" body={serialNoTemplate} header="Seri Numara" filter={true}
                      filterMatchMode={"contains"}/>
              <Column field="barcode" body={barcodeTemplate} header="Barkod" filter={true}
                      filterMatchMode={"contains"}/>
              <Column field="resellerCode" body={resellerCodeTemplate} header="Bayi" filter={true}
                      filterMatchMode={"contains"} headerStyle={{width: "25%"}}/>
              <Column body={accessoryCampaignSerialTitleButtonTemplate}
                      headerStyle={{width: "8rem", textAlign: "center"}}
                      bodyStyle={{textAlign: 'center', overflow: 'visible', justifyContent: 'center'}}/>
            </ResponsiveDataTable>
          </div>
        </div>
        <Dialog header="Arızalı Ürün Detay" visible={detailModal} modal style={{width: '1000px'}}
                onHide={detaillModalHide}>
          <div className="datatable-responsive-demo">
            <div className="p-grid">
              <div className="p-field p-col-12 p-md-6">
                <p className="marginParagraph"><b>Bildirim Tarihi:</b> {selectedProduct?.createDateTimeString}</p>
                <p className="marginParagraph"><b>Durum:</b> {selectedProduct?.faultyProductInfoStatusDisplay}</p>
                <p className="marginParagraph"><b>Bayi Adı:</b> {selectedProduct?.reseller?.name}</p>
                <p className="marginParagraph"><b>Bayi Kodu:</b> {selectedProduct?.reseller?.code}</p>
                <p className="marginParagraph"><b>Bayi Eposta:</b> {selectedProduct.reseller?.email}</p>
                <p className="marginParagraph"><b>Bayi Tel:</b> {selectedProduct.reseller?.phoneNumber}</p>
                <p className="marginParagraph"><b>Bayi Ana Bölge:</b> {selectedProduct.reseller?.mainArea}</p>
                <p className="marginParagraph"><b>Bayi Bölge:</b> {selectedProduct.reseller?.area}</p>
                <p className="marginParagraph"><b>Bayi İl:</b> {selectedProduct.reseller?.resellerProvince?.name}</p>
                <p className="marginParagraph"><b>Bayi İlçe:</b> {selectedProduct.reseller?.resellerDistrict?.name}</p>
                <p className="marginParagraph"><b>Bayi Adres:</b> {selectedProduct.reseller?.addressText}</p>
              </div>
              <div className="p-field p-col-12 p-md-6">
                <p className="marginParagraph"><b>Ürün Seri
                  Numara:</b> {selectedProduct?.productSerialNo?.serialNo != null ? selectedProduct?.productSerialNo?.serialNo : "Yok"}
                </p>
                <p className="marginParagraph"><b>Ürün Marka:</b> {selectedProduct.model?.brand?.name}</p>
                <p className="marginParagraph"><b>Ürün Model:</b> {selectedProduct.model?.name}</p>
                <p className="marginParagraph"><b>Ürün Barkod:</b> {selectedProduct.model?.barcode}</p>
                <hr/>
                {selectedProduct?.saleDateString &&
                <p className="marginParagraph"><b>Satış Tarihi:</b> {selectedProduct?.saleDateString}
                </p>}
                <p className="marginParagraph"><b>Arıza
                  Açıklama:</b> {selectedProduct.description != null ? selectedProduct.description : "Yok"}</p>

                <p className="marginParagraph"><b>Ürünün Fotoğrafları</b></p>
                {selectedProduct && selectedProduct.photos.map((p, i) => {
                  return (<div><a href={p.publicAddress} target="_blank">Fotoğraf {i + 1}</a></div>)
                })}
                {selectedProduct?.faultyProductInfoStatus != "WAITING" && <hr/>}
                {selectedProduct?.completedDateString && <p className="marginParagraph"><b>Bildirimin sonuçlanma
                  tarihi:</b> {selectedProduct.completedDateString}</p>}
                {selectedProduct?.rejectDescription && <p className="marginParagraph"><b>Değişimin reddedilmesinin
                  nedeni:</b> {selectedProduct.rejectDescription}</p>}
                {selectedProduct?.productSaleInfo &&
                <p className="marginParagraph"><b>Yeni ürünün seri numarası:</b> {selectedProduct.productSaleInfo.productSaleInfoDetailList[0].serialNo}
                </p>}
                {selectedProduct?.cargoName &&
                <p className="marginParagraph"><b>Kargo firmasının adı:</b> {selectedProduct.cargoName}
                </p>}
                {selectedProduct?.cargoCode &&
                <p className="marginParagraph"><b>Kargo takip numarası:</b> {selectedProduct.cargoCode}
                </p>}
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  )

};

export default FaultyProductList;
